<template>
  <v-overlay
    v-if="showDialog"
    :modelValue="showDialog"
    class="flex items-center justify-center"
    zIndex="500"
    scrollStrategy="none"
  >
    <v-progress-circular color="#ffffff" indeterminate size="80" width="5"></v-progress-circular>
  </v-overlay>
</template>

<script setup>
defineProps({ showDialog: Boolean });
</script>
